import { ActionMenuItem } from '@shared/components/action-menu/action-menu-item.model';
import { CHECK_PERMISSIONS } from '@shared/modules/permissions.module';
import { ClientActions } from './client-actions-enum';
import { useActionMenuComposable } from '@shared/components/action-menu/action-menu-composable';

export const useClientActionMenu = () => {
  // Composable logic for navigation menu can be added here
  const validatePermission = CHECK_PERMISSIONS();
  const actionMenuHelper = useActionMenuComposable();
  const clientActionMenuItems: ActionMenuItem[] = [
    {
        title:'Details', 
        icon:'info',
        route:'/clients',
        validPermission: validatePermission.canReadClients(),
        action: ClientActions.PageChange,
    },
    {
        title:'Deactivate', 
        statefulTitle: actionMenuHelper.getTruthyStatefulTitle,
        icon:'block',
        route:'/clients',
        validPermission: validatePermission.canReadClients(),
        action: ClientActions.Toggled,
    },
    {
        title:'Edit',
        icon:'edit',
        route:'/clients',
        validPermission: validatePermission.canReadClients(),
        action: ClientActions.Edit,
    },
  ];
    const clientDetailsMenuItems: ActionMenuItem[] = [
    {
        title:'Deactivate', 
        statefulTitle: actionMenuHelper.getTruthyStatefulTitle,
        icon:'block',
        route:'/clients',
        validPermission: validatePermission.canReadClients(),
        action: ClientActions.Toggled,
    },
    {
        title:'Edit',
        icon:'edit',
        route:'/clients',
        validPermission: validatePermission.canReadClients(),
        action: ClientActions.Edit,
    },
  ];
  return{
    clientActionMenuItems,
    clientDetailsMenuItems
  }
};